// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getAnalytics } from "firebase/analytics"; // Zakomentowane
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC24lM6YqoFrQ5khrUyZU9eQ-4SOCO9bac",
  authDomain: "kawalerski-blog.firebaseapp.com",
  projectId: "kawalerski-blog",
  storageBucket: "kawalerski-blog.firebasestorage.app",
  messagingSenderId: "446088766967",
  appId: "1:446088766967:web:1c2ec2c344f4e904683af2",
  measurementId: "G-Z6EXS3YSL4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);